/**
 * Layer definitions for the SECIMS Map Viewer.
 */
import TileLayer from 'ol/layer/Tile';
import VectorTileLayer from 'ol/layer/VectorTile';
import XYZ from 'ol/source/XYZ';
import { PMTilesVectorSource } from 'ol-pmtiles';
import { applyStyle } from 'ol-mapbox-style';
import { layers as protomapsLayers, namedFlavor } from '@protomaps/basemaps';

// ── Basemap layers ───────────────────────────────────────────────

const BASEMAP_SOURCE = 'protomaps';
export const BASEMAP_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors &middot; ' +
  '<a href="https://protomaps.com" target="_blank">Protomaps</a>';

export const basemapLayer = new VectorTileLayer({
  declutter: true,
  source: new PMTilesVectorSource({
    url: '/map/static/stlucia.pmtiles',
    attributions: BASEMAP_ATTRIBUTION
  })
});

applyStyle(
  basemapLayer,
  {
    version: 8,
    glyphs: 'https://protomaps.github.io/basemaps-assets/fonts/{fontstack}/{range}.pbf',
    sprite: 'https://protomaps.github.io/basemaps-assets/sprites/v4/light',
    sources: {
      [BASEMAP_SOURCE]: { type: 'vector', attribution: BASEMAP_ATTRIBUTION }
    },
    layers: protomapsLayers(BASEMAP_SOURCE, namedFlavor('light'), { lang: 'en' })
  },
  BASEMAP_SOURCE,
  { updateSource: false }
);

export const aerialLayer = new TileLayer({
  visible: false,
  source: new XYZ({
    url: 'https://geoservices.govt.lc/geoserver/gwc/service/tms/1.0.0/' +
         'SaintLucia%3Alidar_ortho_2022_10cm@EPSG%3A900913@png/{z}/{x}/{-y}.png',
    crossOrigin: 'anonymous'
  })
});

// ── Project layers ───────────────────────────────────────────────
// Add project layers here as they are added to the map.

// ── Collected config ─────────────────────────────────────────────

// Ordered bottom-to-top for the OL layer stack
export const allLayers = [aerialLayer, basemapLayer];

export const legendConfig = {
  projectLayers: [],
  basemapLayers: [
    {
      label: 'OpenStreetMap (Vector)',
      layer: basemapLayer,
      visible: true,
      downloadUrl: null,
      metadataUrl: null,
      thumbnail: '<svg viewBox="0 0 20 20" width="20" height="20"><circle cx="10" cy="10" r="8.5" fill="none" stroke="#666" stroke-width="1.2"/><ellipse cx="10" cy="10" rx="3.5" ry="8.5" fill="none" stroke="#666" stroke-width="1"/><line x1="1.5" y1="7" x2="18.5" y2="7" stroke="#666" stroke-width="0.8"/><line x1="1.5" y1="13" x2="18.5" y2="13" stroke="#666" stroke-width="0.8"/><line x1="10" y1="1.5" x2="10" y2="18.5" stroke="#666" stroke-width="0.8"/></svg>'
    },
    {
      label: 'Saint Lucia LiDAR Orthophotography 2022',
      layer: aerialLayer,
      visible: false,
      downloadUrl: null,
      metadataUrl: null,
      thumbnail: '<svg viewBox="0 0 20 20" width="20" height="20"><circle cx="10" cy="10" r="8.5" fill="none" stroke="#666" stroke-width="1.2"/><ellipse cx="10" cy="10" rx="3.5" ry="8.5" fill="none" stroke="#666" stroke-width="1"/><line x1="1.5" y1="7" x2="18.5" y2="7" stroke="#666" stroke-width="0.8"/><line x1="1.5" y1="13" x2="18.5" y2="13" stroke="#666" stroke-width="0.8"/><line x1="10" y1="1.5" x2="10" y2="18.5" stroke="#666" stroke-width="0.8"/></svg>'
    }
  ]
};
